import React, { useEffect, useState } from 'react'
import { useTranslation } from 'language/translator'
import { cloneDeep } from 'lodash'

import type { TAttributeOptionDto } from '@homepal/api-contract'
import {
  FilterConditionFormatBody,
  FilterPatchBody
} from 'types/GlobalKpiOption'

import { useAttributeOptions } from 'redux/hooks/AttributeOptions'

import SettingsDrawer from 'components_new/molecules/SettingsDrawer'
import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'

import FilterEditItem from '../FilterEditItem'

import { formatUpdateFilterBody, getFilterBody, getFilterValue } from '../utils'

interface FilterPreviewProps {
  allFilters: FilterConditionFormatBody[] // all filters in order to add,
  filterAttributeOptions: TAttributeOptionDto[]
  // delete or edit.
  filter: FilterConditionFormatBody
  onClose: () => void
  updateFilters: (filters: FilterPatchBody[]) => void
}

const FilterItem = (props: FilterPreviewProps) => {
  const { allFilters, filterAttributeOptions, filter, onClose, updateFilters } =
    props

  const attributeOptions = useAttributeOptions()
  const { t, translateEnum } = useTranslation()

  const attributeOption = filter.attribute_option.selected
    ? attributeOptions[filter.attribute_option.selected]
    : null

  /*-- drawer --*/
  const [drawer, setDrawer] = useState<{
    open: boolean
    title: string
  }>({
    open: false,
    title: ''
  })

  const handleBackDrawer = () => {
    setDrawer((prevState) => ({ ...prevState, open: false }))
  }

  const handleCloseDrawer = () => {
    handleBackDrawer()
    onClose()
  }

  // handleUpdateDrawer
  useEffect(() => {
    if (drawer.open) {
      handleOpenDrawer()
    }
  }, [allFilters])

  const handleOpenDrawer = () => {
    setDrawer({
      open: true,
      title: t('filters', 'filters')
    })
  }

  const handleDelete = () => {
    const newFilters = cloneDeep(allFilters).filter(
      (f) =>
        f.attribute_option.selected !== filter?.attribute_option.selected ||
        f.condition.selected !== filter?.condition.selected ||
        f.type.selected !== filter?.type.selected ||
        f.filter_group_id !== filter?.filter_group_id
    )

    updateFilters(formatUpdateFilterBody(newFilters))
    handleBackDrawer()
  }

  return (
    <>
      <SettingsItem
        onClick={handleOpenDrawer}
        body={getFilterBody(filter) ?? undefined}
        title={attributeOption?.name}
        value={getFilterValue(filter, t, translateEnum)}
      />

      {/*-- drawer --*/}
      <SettingsDrawer
        open={drawer.open}
        onBack={handleBackDrawer}
        onClose={handleCloseDrawer}
        title={drawer.title}
      >
        <FilterEditItem
          allFilters={allFilters}
          filterAttributeOptions={filterAttributeOptions}
          filter={filter}
          updateFilters={updateFilters}
        />
        <SettingsGroup>
          <SettingsItem
            color="error"
            onClick={handleDelete}
            title={t('global', 'delete')}
            variant="action"
          />
        </SettingsGroup>
      </SettingsDrawer>
    </>
  )
}

export default FilterItem
